import React from "react";
import { paymentTypes } from "../../../../utils/constants";
import { Col, FormGroup, Input, Label, Row, InputGroup } from "reactstrap";
import { LabelWithToolTip } from "../../../atoms/LabelWithToolTip";

const RegNoAccountForm = (props) => {
  const field = (label, value) => (
    <div className="vbdm__field">
      <div className="vbdm__field-label">{label}</div>
      <div className={`vbdm__field-value${!value ? ' vbdm__field-value--empty' : ''}`}>
        {value || '\u2014'}
      </div>
    </div>
  );

  return (
    <FormGroup
      style={{
        display:
          props.checkbox === paymentTypes.REGNOACCOUNT ? "block" : "none",
      }}
    >
      <FormGroup>
        <LabelWithToolTip
          id="labelRegistrationNumber"
          labelText="Registration Number *"
          tooltipText="Bank's registration number (sort code) that identifies the bank branch. Must be exactly 4 characters. Only alphanumeric characters allowed."
        />
        <Row>
          <Col sm="12">
            <input
              type="text"
              value={props.regNo}
              className= "form-control"
              {...props.register("regNo")}
              onChange={props.handleOnChangeRegistrationNo}
              maxLength="4"
            />
          </Col>
        </Row>
      </FormGroup>
      <FormGroup
        style={{
          display:
            props.checkbox === paymentTypes.REGNOACCOUNT ? "block" : "none",
        }}
      >
        <LabelWithToolTip
          id="labelAccountNumber"
          labelText="Account Number *"
          tooltipText="Bank account number as it appears on your bank statement. Must be exactly 10 characters. Only alphanumeric characters allowed. Spaces and hyphens (-) are not permitted."
        />
        <Row>
          <Col sm="12">
            <InputGroup>
              <input
                type="text"
                {...props.register("bankAccountNumber")}
                className= "form-control"
                onChange={props.handleAccountNo}
                maxLength="10"
              />
            </InputGroup>
          </Col>
        </Row>
      </FormGroup>

      {props.isRegNoAccountValidated && (
        <div className="swift-results">
          <div className="swift-results__section">
            <div className="swift-results__fields">
              <input type="hidden" {...props.register("calculatedIban")} />
              <input type="hidden" {...props.register("bic")} />
              <input type="hidden" {...props.register("bankName")} />
              <input type="hidden" {...props.register("bankAddress")} />
              <input type="hidden" {...props.register("bankCity")} />
              <input type="hidden" {...props.register("bankZip")} />
              <input type="hidden" {...props.register("bankCountry")} />
              <div className="vbdm__grid">
                {field("IBAN", props.getValues("calculatedIban"))}
                {field("SWIFT", props.getValues("bic"))}
                {field("Bank", props.getValues("bankName"))}
                {field("Address", props.getValues("bankAddress"))}
                {field("City", props.getValues("bankCity"))}
                {field("Postal Code", props.getValues("bankZip"))}
                {field("Country", props.getValues("bankCountry"))}
              </div>
            </div>
          </div>
        </div>
      )}
    </FormGroup>
  );
};

export default RegNoAccountForm;
